import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { getUrl } from '../../helpers/api/api';
import { pcoAuthLogin_endpoint } from '../../helpers/api/apiConstants';

// Congregant-facing login, separate from the admin portal's email/password
// Login - anyone with a Planning Center account with the church can sign
// in, no admin credentials needed.
const PortalLogin = () => {
  const theme = useTheme();

  const mainStyle = {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: theme.typography.fontFamily,
    paddingTop: 'var(--nav-height)',
    minHeight: '100vh',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.brand.linen,
  };

  const eyebrowStyle = {
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: theme.palette.brand.brass,
    margin: '0 0 6px',
    textAlign: 'center',
  };

  const handleLogin = () => {
    window.location.href = getUrl(pcoAuthLogin_endpoint);
  };

  return (
    <div style={mainStyle}>
      <Box
        sx={{
          width: '100%',
          maxWidth: '360px',
          padding: '36px 28px',
          boxSizing: 'border-box',
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.brand.border}`,
          borderRadius: '10px',
          textAlign: 'center',
        }}
      >
        <div style={eyebrowStyle}>Bethel Bible Church</div>
        <h1
          style={{
            fontFamily: theme.typography.secondaryFontFamily,
            color: theme.palette.primary.dark,
            fontSize: '30px',
            fontWeight: 600,
            margin: '0 0 12px',
          }}
        >
          Congregant Portal
        </h1>
        <p
          style={{
            fontFamily: theme.typography.paragraphFontFamily,
            fontSize: '13px',
            color: theme.palette.text.secondary,
            margin: '0 0 24px',
          }}
        >
          Sign in with your Planning Center account to continue.
        </p>

        <Button
          variant="contained"
          fullWidth
          onClick={handleLogin}
          sx={{ borderRadius: '6px', padding: '10px 0' }}
        >
          Continue with Planning Center
        </Button>
      </Box>
    </div>
  );
};

export default PortalLogin;
